module.exports = __webpack_public_path__ + "img/back04.ab0ad9a2.png";